export const localStorageService = {
  getAccessRefreshToken() {
    return localStorage.getItem("access_refresh_token")
  },

  getAccessToken() {
    return localStorage.getItem("access_token")
  },

  getUserUuid() {
    return localStorage.getItem("user_uuid")
  },
  getUserIri() {
    return localStorage.getItem("user_iri")
  },

  getUserAccountIri() {
    return localStorage.getItem("user_account")
  },

  setAccessRefreshToken(newVal) {
    return localStorage.setItem("access_refresh_token", newVal)
  },

  setAccessToken(newVal) {
    return localStorage.setItem("access_token", newVal)
  },
  setUserUuid(newVal) {
    return localStorage.setItem("user_uuid", newVal)
  },
  setUserAccountIri(newVal) {
    return localStorage.setItem("user_account", newVal)
  },
  setUserIri(newVal) {
    return localStorage.setItem("user_iri", newVal)
  },

  setTranslations(newVal) {
    localStorage.setItem("translations", newVal)
  },
  getTranslations() {
    return localStorage.getItem("translations")
  },

  removeAccessToken() {
    localStorage.removeItem("access_token")
  },
  removeAll() {
    return [
      "access_refresh_token",
      "access_token",
      "user_uuid",
      "user_account",
      "user_iri",
      "access_refresh_token"
    ].forEach((item) => localStorage.removeItem(item))
  }
}
